module.exports = __webpack_public_path__ + "static/media/image04.8ddbb4f9.png";